
// reducer.js
const initialState = {
  selectedItemText: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SELECT_ITEM_TEXT':
      return {
        ...state,
        selectedItemText: action.payload,
      };
    default:
      return state;
  }
};

export default rootReducer;